import { announcementBannerSettingsV4Resource } from '@jira/admin-pages__system-announcement-banner-resources/src/useAnnouncementBannerSettingsV4Resource.tsx';
import { assetsReportingConfigResource } from '@jira/router-resources__assets-reports/src/useAssetsReportingConfigResource.tsx';
import { workspaceResource } from '@jira/servicedesk__insight-common-services-workspace-context/src/workspaceResource.tsx';
import { assetsUserPermissionResource } from '@jira/router-resources__assets-user-permission/src/useAssetsUserPermission.tsx';
import {
	assetsBannerSettingsResource,
	assetsLogoAndFaviconResource,
	assetsNavigationSettingsResource,
	assetsUserSettingsResource,
} from '@jira/router-resources__assets-admin-settings/src/useAssetsNavigationSettingsResource.tsx';
import { getConsentBannerUserPreferencesResource } from '@jira/router-resources__cookie-consent/src/useConsentBannerUserPreferencesResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { dataManagerAdvisoryNotificationsResource } from '@jira/router-resources__assets-data-manager-advisory-notifications/src/dataManagerAdvisoryNotificationsResource.tsx';
import { getServicedeskPageContextResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { rovoEntitlementResource } from '@jira/router-resources__rovo-entitlement/src/useRovoEntitlementResource.tsx';
import { ubpEnablementResource } from '@jira/router-resources__ubp-enablement/src/ubpEnablementResource.tsx';
import {
	postOfficeAssetsSideNavUpsellDashboardsPlacementResource,
	postOfficeAssetsSideNavUpsellDataManagerPlacementResource,
} from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteResource } from '@atlassian/react-resource-router';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export function getCmdbResources(): RouteResource<any>[] {
	return [
		...getNavigationResources(),
		...getServicedeskPageContextResources(),
		workspaceResource,
		resourceWithCondition(() => fg('assets-platform-landing-page'), ubpEnablementResource),
	];
}

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export function getAssetsAppResources(): RouteResource<any>[] {
	return [
		...jiraSpaResources(),
		workspaceResource,
		resourceWithCondition(() => fg('aurum-997-license-kill-switch'), assetsUserPermissionResource),
		resourceWithCondition(
			() => fg('assets-announcement-banner-settings'),
			assetsNavigationSettingsResource,
		),
		resourceWithCondition(
			() => fg('assets-announcement-banner-settings'),
			assetsBannerSettingsResource,
		),
		resourceWithCondition(
			() => fg('assets-announcement-banner-settings'),
			assetsUserSettingsResource,
		),
		resourceWithCondition(
			() => fg('assets-announcement-banner-settings'),
			assetsLogoAndFaviconResource,
		),
		resourceWithCondition(
			() => fg('sqa-2098-assets-platform-app-nav-upsells'),
			postOfficeAssetsSideNavUpsellDashboardsPlacementResource,
		),
		resourceWithCondition(
			() => fg('sqa-2098-assets-platform-app-nav-upsells'),
			postOfficeAssetsSideNavUpsellDataManagerPlacementResource,
		),
		rovoEntitlementResource,
		getConsentBannerUserPreferencesResource(),
		announcementBannerSettingsV4Resource,
		assetsReportingConfigResource,
		resourceWithCondition(
			() => fg('assets_data_manager_advisory_notifications'),
			dataManagerAdvisoryNotificationsResource,
		),
		// Also registered on getCmdbResources. The upsell renders from AssetsAppBase on both the
		// legacy /jira/servicedesk/assets/* routes and the modern /jira/assets/* ones, so both
		// helpers need the signal or the surface it does not cover cannot tell "UBP off" apart
		// from "never asked".
		resourceWithCondition(() => fg('assets-platform-landing-page'), ubpEnablementResource),
	];
}
